// Pieces shared by the own-system tabs and the other system views.
import type { FullSystem, PublicSystem } from '@stars-and-ships/api-types';
import { formatDuration } from '../../labels';

export function PlanetsLine({ system }: { system: Pick<PublicSystem, 'planets'> }) {
  const p = system.planets;
  return (
    <p className="text-sm text-muted">
      {p.orePlanets} ore planets · {p.gasGiants} gas giants · {p.earthLikes} earth-likes
    </p>
  );
}

/** Open claims on an own system (owner view, 04 §3.6): who, and when it can be captured. */
export function ClaimsNotice({ system, now }: { system: FullSystem; now: number }) {
  if (system.claims.length === 0) return null;
  const left = (iso: string) => formatDuration(Math.max(0, Date.parse(iso) - now));
  return (
    <ul className="space-y-2" data-system-claims>
      {system.claims.map((c) => (
        <li
          key={c.id}
          className="hud-cut-sm border border-danger/50 bg-danger/10 p-3 text-sm text-danger"
        >
          {c.claimant.displayName}
          {c.claimant.allianceTag ? ` [${c.claimant.allianceTag}]` : ''} has claimed this system —{' '}
          {c.status === 'pending'
            ? `activates in ${left(c.activatesAt)}`
            : `active: a won battle captures it (expires in ${left(c.expiresAt)})`}
        </li>
      ))}
    </ul>
  );
}

/** A whole, positive amount typed into a field; anything else counts as 0. */
export const parseAmount = (value: string) => {
  const n = Number.parseInt(value, 10);
  return Number.isFinite(n) && n > 0 ? n : 0;
};
